var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from 'class-transformer';
import { IsEnum, IsOptional, IsUUID } from 'class-validator';
import { PaginationQuery } from '../../pagination-query.js';
import { TreatmentPlanStatus } from '../enums/treatment-plan-status.enum.js';
export class FindTreatmentPlansQueryDto extends PaginationQuery {
    patientId;
    status;
    payerDomainId;
}
__decorate([
    Expose(),
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], FindTreatmentPlansQueryDto.prototype, "patientId", void 0);
__decorate([
    Expose(),
    IsEnum(TreatmentPlanStatus),
    IsOptional(),
    __metadata("design:type", String)
], FindTreatmentPlansQueryDto.prototype, "status", void 0);
__decorate([
    Expose(),
    IsUUID(),
    IsOptional(),
    __metadata("design:type", String)
], FindTreatmentPlansQueryDto.prototype, "payerDomainId", void 0);
//# sourceMappingURL=find-treatment-plans-query.dto.js.map